import { ChakraProvider } from "@chakra-ui/react";
import CourseLayout from "layouts/course";
import FormationLayout from "layouts/formations";
import TestLayout from "layouts/test";
import ReactDOM from "react-dom";
import { isExpired } from "react-jwt";
import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { store } from "redux/store";
import "./assets/css/App.css";
import Firebase from "./firebase";
import AdminLayout from "./layouts/admin";
import AuthLayout from "./layouts/auth";
import FormateurLayout from "./layouts/formateur";
import UserLayout from "./layouts/user";
import theme from "./theme/theme";

import Error from "./Error";

const user = window.localStorage.getItem("user");
const isAuthenticated = localStorage.getItem("token") != null;
const token =
  JSON.parse(localStorage.getItem("user")) != null
    ? JSON.parse(localStorage.getItem("user")).access_token
    : "";
const isTokenExpired = isExpired(token);
console.log({ isTokenExpired });
console.log({ user });
ReactDOM.render(
  <Error>
    <Provider store={store}>
      <Firebase>
        <ChakraProvider theme={theme}>
          <BrowserRouter>
            <Switch>
              <Route path={`/auth`} component={AuthLayout} />
              <Route path={`/user`} component={UserLayout} />
              <Route path={`/formations`} component={FormationLayout} />
              <Route path={`/course`} component={CourseLayout} />
              <Route path={`/test`} component={TestLayout} />
              <Route path={`/admin`} component={AdminLayout} />
              <Route path={`/formateur`} component={FormateurLayout} />
              <Redirect
                from="/"
                to={
                  isTokenExpired === true
                    ? "/auth"
                    : JSON.parse(user).roleId === 1
                    ? "/admin"
                    : "/user/formations"
                }
              />
            </Switch>
          </BrowserRouter>
        </ChakraProvider>
      </Firebase>
    </Provider>
  </Error>,
  document.getElementById("root")
);
